import store from '@/store/store'
import cookie from 'vue-cookie'
import https from '@/utils/http'
import {message} from 'ant-design-vue'
import api from '@/api/index';
// 复制
export const CopyText = function (str, callBack, notoast = '') {
    var tmp = document.createElement("span");
    tmp.innerText = str;

    tmp.style['user-select'] = 'text';
    tmp.style['-webkit-user-select'] = 'text';
    tmp.style['-moz-user-select'] = 'text';
    tmp.style['-ms-user-select'] = 'text';

    document.body.appendChild(tmp);
    var range = document.createRange();
    range.selectNode(tmp);
    var selection = window.getSelection();
    if (selection.rangeCount > 0) {
        selection.removeAllRanges();
    }
    selection.addRange(range);
    var result = document.execCommand("copy");
    document.body.removeChild(tmp);
    if (!notoast) {
        if(this.detectDeviceType){
          this.$toast('复制成功！')
        }else{
          this.$message.success('复制成功！')
        }
    }
    // 关闭时回调
    if (typeof (callBack) === "function") {
        callBack('CopyIsOk')
    }
    return result;
};
// 判断客户端
export const judgeClient  = () =>{
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
    if(isAndroid){
      return 'Android';
    }else if(isIOS){
      return 'ios';
    }else{
      return 'pc';
    }
}
// 判断是否在Safari浏览器
export const isSafari = ()=>{
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
    ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1  && ua.indexOf('browser') === -1 && /(mac os.*safari.*)/i.test(navigator.userAgent) && !window.chrome;
    // return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
// 判断是否在微信端
export const isWeixin = () =>{
  return /MicroMessenger/i.test(navigator.userAgent);
}
// 判断移动端｜PC端
export const detectDeviceType = () =>{
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// 路由跳转
export const openChatRouter = function (Obj = { path: "/", target: '', type: '', query: {} }) {
  // 在新窗口中打开
  if (Obj.target == '_blank') {
    window.open(Obj.path)
  } else {
    if (Obj.type == 'replace') {
      // 不回留下history 记录
      this.$router.replace({
          path: Obj.path,
          query: Obj.query
      })
      } else {
        this.$router.push({
          path: Obj.path,
          query: Obj.query
        })
      }
  }
}
// 获取用户信息
export const getUserInfo = (callBack)=>{
  api.getGptUserInfo({token:store.state.token}).then(res=>{
    if(res.success){
      store.dispatch('setUpdateUserInfo',res.data)
      if(res.data){
        store.dispatch('setIsLogin',true)
      }
      if(callBack && typeof callBack == 'function'){
        callBack()
      }
    }
  })
}
// 分享模版
export const shareTemplate = (id)=>{
  let url = `https://topchat.com.cn/v1/sharetopchat?templateID=${id}`
  CopyText(url,null,'custom');
  message.success('链接已复制，请在微信端打开试用')
}
// 防抖
export function debounce(fn, delay) {
  let timer = null;
  return function(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
// 判断图片链接
export function isImageLink(url) {
  try {
    const pattern = /\.(jpeg|jpg|gif|png|bmp|webp)$/i;
    // 忽略参数部分
    const urlWithoutParams = url.split('?')[0];
    return pattern.test(urlWithoutParams);
  } catch (error) {
    return false;
  }
  
}
// 判断对象是否为空
export function isObj(obj){
  try {
    if (Object.keys(obj).length === 0) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * @description: 获取图片正确地址时机
 * @param {String} url         // 图片url
 * @param {Number} retryCount  // 重试次数
 * @param {Number} maxRetries  // 最大重试数
 * @param {Number} delay       // 延时时间(默认两秒)
 */
export function checkImageValidity(url, retryCount = 0, maxRetries = 10, delay = 2000) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function() {
      resolve(url);
    };
    img.onerror = function() {
      if (retryCount < maxRetries) {
        setTimeout(() => {
          checkImageValidity(url, retryCount + 1, maxRetries, delay)
            .then(resolve)
            .catch(reject);
        }, delay);
      } else {
        reject(new Error('图片加载失败'));
      }
    };
    img.src = url;
  });
}
// 三位分节法
export function formatNumber(num) {
  // 先将数字转化为字符串，以便于进行字符串操作
  let str = num.toString()
  // 将字符串从小数点处分割成整数部分和小数部分，如果没有小数部分，则小数部分默认为 ''
  let [integer, decimal = ''] = str.split('.')
  // 从整数部分的末位开始，每三位数字分割一次，使用逗号或者点号隔开
  let result = []
  for (let i = integer.length - 1, j = 1; i >= 0; i--, j++) {
    result.unshift(integer[i])
    if (j % 3 === 0 && i !== 0) {
      result.unshift(',')
    }
  }
  // 如果小数部分为空，则说明输入的数字没有小数部分，无需再添加小数点
  if (!decimal) {
    return result.join('')
  } else {
    return result.join('.') + '.' + decimal
  }
}
